
const API_BASE_URL = process.env.REACT_APP_API_URL

  export async function login(email, password) {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, password })
  });
  return response.json();
}

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);

  const response = await fetch(`${API_BASE_URL}/admin/upload`, {
    method: "POST",
    body: form,
    credentials: "include"
  });

  return response.json();
}

export async function listMedia() {
  const response = await fetch(`${API_BASE_URL}/admin/media`, {
    credentials: "include"
  });
  return response.json();
}

// export async function createCategory(data) {
//   const res = await fetch(`${API}/admin/post-category`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data),
//   });
//   if (!res.ok) throw new Error("Errore nella creazione della serie");
//   return res.json();
// }

export async function createProduct(formData){
  const res = await fetch(`${API_BASE_URL}/admin/product/new`, {
        method: 'POST',
        credentials: "include",
        headers: {
          "Accept": "application/json"
        },
        
        body: formData,
      });
      if (!res.ok) throw new Error("Erreur dans la creation du product");
  return res.json();
}

export async function updateProduct(product) {
  const res = await fetch(`${API_BASE_URL}/admin/product/update/${product.id}`, {
    method: 'PUT',
    credentials: "include",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(product),
  });
  if (!res.ok) throw new Error("Erreur dans la mise à jour du produit");
  return res.json();
}



export async function createCategory(payload) {
  const res = await fetch(`${API_BASE_URL}/admin/create-category`, {
    method: "POST",
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error("Erreur dans la creation de la categorie");
  return res.json();
}

export async function createMedia(formData, prodID){
  const res = await fetch(`${API_BASE_URL}/admin/medias/create/${prodID}`, {
        method: 'POST',
        credentials: "include",
        headers: {
          "Accept": "application/json"
        },
        body: formData,
      });
      if (!res.ok) throw new Error("Erreur dans la creation du product");
  return res.json();
}


export async function deleteMedia(mediaId){
  const res = await fetch(`${API_BASE_URL}/admin/medias/delete/${mediaId}`, {
        method: 'DELETE',
        credentials: "include",
        headers: { 
          "Accept": "application/json"
        },
      });
      if (!res.ok) throw new Error("Erreur dans la supression du media");
  return res.json();
}


export async function deleteProduct(productID){
  const res = await fetch(`${API_BASE_URL}/admin/product/delete/${productID}`, {
        method: 'DELETE',
        credentials: "include",
         headers: {
          "Accept": "application/json"
        },
      });
      if (!res.ok) throw new Error("Erreur dans la suppression du product");
  return res.json();
}

export async function updateConfig(formData){
  const res = await fetch(`${API_BASE_URL}/admin/site-settings`, {
        method: 'POST',
        credentials: "include",
        headers: {
          "Accept": "application/json"
        },
        body: formData,
      });
      if (!res.ok) throw new Error("Erreur dans la sauvegarde");
  return res.json();
}

export async function deleteBackground(fieldName){
  const res = await fetch(`${API_BASE_URL}/admin/settings/delete-background`, {
        method: 'POST',
        credentials: "include",
        headers: {
          "Accept": "application/json"
        },
        body: JSON.stringify({ fieldName }),
      });
      if (!res.ok) throw new Error("Erreur dans la suppression du product");
  return res.json();
}

export async function getStats(){
  const res = await fetch(`${API_BASE_URL}/statistics`, {
        method: 'GET',
        credentials: "include",
        headers: {
          "Accept": "application/json"
        }
      });
      if (!res.ok) throw new Error("Erreur dans la recuperation des stats");
  return res.json();
}

export const getUsers = async () => {
  const response = await fetch(
    `${API_BASE_URL}/admin/users`, {
      method: 'GET',
      credentials: "include",
    });
  if (!response.ok) throw new Error("Failed to fetch users");
  return response.json();
};

export const createUser = async (userData) => {
  const response = await fetch(`${API_BASE_URL}/admin/user`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",

    },
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to create user");
  }
  return response.json();
};

export const updateUser = async (userData) => {
  const response = await fetch(`${API_BASE_URL}/users/${userData.id}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to update user");
  }
  return response.json();
};




